import { useEffect, useState } from 'react';
import { pickBuildingSynonym } from '../utils/buildingSynonyms';
import '../assets/css/BuildingShimmer.css';

const ROTATE_MS = 30000;

/**
 * Animated shimmer label cycling random "building" synonyms every 30s.
 */
function BuildingShimmerText({ className = '' }) {
  const [synonym, setSynonym] = useState(() => pickBuildingSynonym());

  useEffect(() => {
    const id = window.setInterval(() => {
      setSynonym((current) => pickBuildingSynonym(current));
    }, ROTATE_MS);
    return () => window.clearInterval(id);
  }, []);

  return (
    <span
      className={`building-shimmer-label ${className}`.trim()}
      aria-live="polite"
      aria-atomic="true"
    >
      <span className="building-shimmer">{synonym}…</span>
      {' your BILDIT Visual Experience Engine'}
    </span>
  );
}

export default BuildingShimmerText;
